import { enableMapSet } from 'immer';

import configureStoreProd from './configureStore.prod';
import configureStoreDev from './configureStore.dev';
import { createLoadedPersistedStateActions } from './persistWidgetBlockStateMiddleware';

enableMapSet();

//TODO: Is there a way to *only* load the relevant configureStore?
//Import() makes it async (unlike require), which breaks everything. Which is problematic because it means whatever imports this needs to become async.
//We could make a dummy object that simply gets replaced by the real thing, but this will break for things such as getState();
const configureStoreWrapper = (...args) => {
    const configureStore =
        process.env.NODE_ENV === 'production' || (window.location && window.location.hostname !== 'localhost') ? configureStoreProd : configureStoreDev;

    const store = configureStore(...args);
    createLoadedPersistedStateActions().forEach((action) => store.dispatch(action));
    return store;
};

export default configureStoreWrapper;
